module.exports = __webpack_public_path__ + "static/media/banner1.28e58f30.svg";